import { Stats } from 'game/core'
import { MountedConfig } from 'game/extended/creatures/goblins/abilities/mounted/mounted'
import { goblin_chief } from 'game/extended/creatures/goblins/goblin_chief/goblin_chief'

export const mounted_config: Array<MountedConfig> = [
    {
        unmounted_stats: goblin_chief.definition(1).stats as unknown as Stats
    }
]